<template>
  <b-container fluid class="animated fadeIn">
    <b-row align-h="start" align-v="center">
      <b-col cols="3">
        <h2>{{ uniTranslation("PHE564") }}</h2>
      </b-col>
      <b-col cols="1">
        <b-form-checkbox v-show="false" id="pubblica" v-model="fluid.pubblica">{{
          uniTranslation("GCN37")
        }}</b-form-checkbox>
      </b-col>
      <b-col offset="2">
        <b-button
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          :disabled="bLoading"
          @click="saveFluidDialog"
          >{{ uniTranslation("GF10") }}</b-button
        >&nbsp;

        <b-button
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          @click="goToBack"
          :disabled="bLoading"
          >{{ uniTranslation("S758") }}</b-button
        >&nbsp;
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <b-card :title="uniTranslation('S654')" class="mb-2">
          <b-row>
            <b-col>
              <!-- Description -->
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('GF130') + ' ID'"
                label-for="description"
              >
                <b-form-input
                  id="description"
                  v-model="fluid.descriptionId"
                  :disabled="true"
                  size="sm"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('GF130')"
                label-for="fluidDescription"
              >
                <b-form-input
                  id="fluidDescription"
                  v-model="fluid.fluidDescription"
                  size="sm"
                  @change="assertMaxChars(21)"
                ></b-form-input>
                <p v-show="bShowDescriptionMsg" style="text-align:left; font-size: 13px;color: red">
                  {{ uniTranslation("PHE20280") }}
                </p>
              </b-form-group>

              <!-- File Name -->
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('GF113')"
                label-for="filename"
              >
                <b-form-input
                  id="filename"
                  v-model="fluid.filename"
                  size="sm"
                  :disabled="fluid.id == -1"
                ></b-form-input>
              </b-form-group>

              <!-- Min / Max / Freezing Temps -->
              <span v-show="fluid.tipoFluido == 11 || fluid.tipoFluido == 13">
                <b-form-group
                  label-cols-lg="4"
                  label-size="sm"
                  :label="uniTranslation('GF128')"
                  label-for="minTemp"
                >
                  <b-form-input
                    id="minTemp"
                    v-model="fluid.tempMin"
                    size="sm"
                    type="number"
                  ></b-form-input>
                  <p v-show="bShowMinTempMsg" style="text-align:left; font-size: 13px;color: red">
                    {{ uniTranslation("PHE20280") }}
                  </p>
                </b-form-group>
                <b-form-group
                  label-cols-lg="4"
                  label-size="sm"
                  :label="uniTranslation('GF127')"
                  label-for="maxTemp"
                >
                  <b-form-input
                    id="maxTemp"
                    v-model="fluid.tempMax"
                    size="sm"
                    type="number"
                  ></b-form-input>
                  <p v-show="bShowMaxTempMsg" style="text-align:left; font-size: 13px;color: red">
                    {{ uniTranslation("PHE20280") }}
                  </p>
                </b-form-group>
                <b-form-group
                  label-cols-lg="4"
                  label-size="sm"
                  :label="uniTranslation('GF126')"
                  label-for="freezingTemp"
                >
                  <b-form-input
                    id="freezingTemp"
                    v-model="fluid.freezingTemp"
                    size="sm"
                    type="number"
                  ></b-form-input>
                  <p v-show="bShowFreezeMsg" style="text-align:left; font-size: 13px;color: red">
                    {{ uniTranslation("PHE20280") }}
                  </p>
                </b-form-group>
              </span>
              <!-- Molecular Weight -->
              <b-form-group
                v-show="fluid.tipoFluido == 13"
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('GF118')"
                label-for="molecularWeight"
              >
                <b-form-input
                  id="molecularWeight"
                  v-model="fluid.molecularWeight"
                  size="sm"
                  type="number"
                ></b-form-input>
                <p
                  v-show="bShowMolecularWeightMsg"
                  style="text-align:left; font-size: 13px;color: red"
                >
                  {{ uniTranslation("PHE20280") }}
                </p>
              </b-form-group>

              <!-- Data Type -->
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('GF125')"
                label-for="dataType"
              >
                <b-form-select
                  id="dataType"
                  v-model="fluid.tipoDati"
                  :options="tipoDatiOptions"
                  size="sm"
                ></b-form-select>
              </b-form-group>

              <!-- Fast -->
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('GF129')"
                label-for="fastOpt"
              >
                <b-form-select
                  id="fastOpt"
                  v-model="fluid.fast"
                  :options="fastOptions"
                  size="sm"
                ></b-form-select>
              </b-form-group>

              <!-- Group "Dangerous (G1 = yes,G2 = no)" -->
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('PHE10198')"
                label-for="group"
              >
                <b-form-select
                  id="group"
                  v-model="fluid.group"
                  :options="gruppoOptions"
                  size="sm"
                ></b-form-select>
                <p v-show="bShowFluidMsg" style="text-align:left; font-size: 13px;color: red">
                  {{ uniTranslation("PHE20280") }}
                </p>
                <!-- <b-form-input id="group" v-model="fluid.group" size="sm"></b-form-input> -->
              </b-form-group>

              <!-- VapourPressure "Vapour pressure > 0,5 bar temperature (°C)" -->
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('PHE10199')"
                label-for="vapourPressure"
              >
                <b-form-input
                  id="vapourPressure"
                  v-model="fluid.vapourPressure"
                  size="sm"
                  type="number"
                ></b-form-input>
                <p v-show="bShowPressureMsg" style="text-align:left; font-size: 13px;color: red">
                  {{ uniTranslation("PHE20280") }}
                </p>
              </b-form-group>

              <!-- flashPointTemperature "Flash point temperature (°C)" -->
              <b-form-group
                label-cols-lg="4"
                label-size="sm"
                :label="uniTranslation('PHE10201')"
                label-for="flashPointTemperature"
              >
                <b-form-input
                  id="flashPointTemperature"
                  v-model="fluid.flashPointTemperature"
                  size="sm"
                  type="number"
                ></b-form-input>
                <p v-show="bShowFlashPointMsg" style="text-align:left; font-size: 13px;color: red">
                  {{ uniTranslation("PHE20280") }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="8">
        <b-card v-if="fluid.tipoDati == 1" :title="uniTranslation('GF124')" class="mb-2">
          <b-table
            hover
            :items="fluid.points"
            :fields="fields"
            :small="true"
            :sticky-header="false"
          >
            <template v-slot:cell(temperature)="row">
              <!--<b-form-input v-model="row.item.temperature" size="sm" />-->
              <FluidPropEditor
                v-model="row.item.temperature"
                :factor="temperatureUmFactor"
                :offset="temperatureUmOffSet"
                :input-decimal-num="temperatureUmDecimals"
                :delta="32"
              />
            </template>
            <template v-slot:cell(density)="row">
              <!--<b-form-input v-model="row.item.density" size="sm" />-->
              <FluidPropEditor
                v-model="row.item.density"
                :factor="densityUmFactor"
                :input-decimal-num="densityUmDecimals"
              />
            </template>
            <template v-slot:cell(specificHeat)="row">
              <!--<b-form-input v-model="row.item.specificHeat" size="sm" />-->
              <FluidPropEditor
                v-model="row.item.specificHeat"
                :factor="specificHeatUmFactor"
                :input-decimal-num="specificHeatUmDecimals"
              />
            </template>
            <template v-slot:cell(thermalConductivity)="row">
              <!--<b-form-input v-model="row.item.thermalConductivity" size="sm" />-->
              <FluidPropEditor
                v-model="row.item.thermalConductivity"
                :factor="thermalCondUmFactor"
                :input-decimal-num="thermalCondUmDecimals"
              />
            </template>
            <template v-slot:cell(viscosity)="row">
              <!--<b-form-input v-model="row.item.viscosity" size="sm" />-->
              <FluidPropEditor
                v-model="row.item.viscosity"
                :factor="viscosityUmFactor"
                :input-decimal-num="viscosityUmDecimals"
              />
            </template>
          </b-table>
          <b-row><hr /></b-row>
          <b-row>
            <b-col cols="1">&nbsp;</b-col>
            <b-col cols="2">
              <FluidUmSelector
                v-model="temperatureUm"
                :category="'Temperature'"
                :label="'Temperature'"
                :can-change-value="canChangeValue"
              />
            </b-col>
            <b-col cols="2">
              <FluidUmSelector v-model="densityUm" :category="'Density'" :label="'Density'" />
            </b-col>
            <b-col cols="2">
              <FluidUmSelector
                v-model="specificHeatUm"
                :category="'Specific Heat'"
                :label="'Specific Heat'"
              />
            </b-col>
            <b-col cols="2">
              <FluidUmSelector
                v-model="thermalCondUm"
                :category="'Thermal Conductivity'"
                :label="'Thermal Conductivity'"
              />
            </b-col>
            <b-col cols="2">
              <FluidUmSelector
                v-model="viscosityUm"
                :category="'Dynamic Viscosity'"
                :label="'Viscosity'"
              />
            </b-col>
            <b-col cols="1">&nbsp;</b-col>
          </b-row>
        </b-card>
        <b-card v-if="fluid.tipoDati == 2" :title="uniTranslation('GF123')" class="mb-2">
          <b-table
            hover
            :items="fluid.coefficients"
            :fields="fields"
            :small="true"
            :sticky-header="false"
          >
            <template v-slot:cell(density)="row">
              <b-form-input v-model="row.item.density" size="sm" />
            </template>
            <template v-slot:cell(specificHeat)="row">
              <b-form-input v-model="row.item.specificHeat" size="sm" />
            </template>
            <template v-slot:cell(thermalConductivity)="row">
              <b-form-input v-model="row.item.thermalConductivity" size="sm" />
            </template>
            <template v-slot:cell(viscosity)="row">
              <b-form-input v-model="row.item.viscosity" size="sm" />
            </template>
          </b-table>
        </b-card>
        <b-card
          v-if="fluid.tipoDati != 1 && fluid.tipoDati != 2"
          :title="uniTranslation('S840')"
          class="mb-2"
        >
          <b-table
            hover
            :items="fluid.components"
            :fields="fields"
            :small="true"
            :sticky-header="false"
          >
            <template v-slot:cell(fluid)="row">
              <b-form-select
                id="dataType"
                v-model="row.item.fluid"
                :options="baseFluidList"
                size="sm"
              ></b-form-select>
            </template>
            <template v-slot:cell(percentage)="row">
              <b-form-input v-model="row.item.percentage" size="sm" />
            </template>
          </b-table>
          <p v-if="wrongPerc">{{ uniTranslation("GF152") }}</p>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="bshowRetMsg"
      ok-only
      size="sm"
      hide-backdrop
      :title="uniTranslation('PHE564')"
    >
      <p class="my-2">{{ retUptMsg }}</p>
    </b-modal>
  </b-container>
</template>

<script>
import fluidMgtService from "@/services/backend/fluidMgtService";
import fluidService from "@/services/backend/fluidService";
import fluidGroupService from "@/services/backendCipriani/generalService";
import FluidPropEditor from "./FluidPropEditor";
import FluidUmSelector from "./FluidUmSelector";
import umService from "../../services/backend/umService";
import colorsService from "@/services/backend/colorsService";

export default {
  name: "FluidEdit",
  components: {
    FluidPropEditor,
    FluidUmSelector
  },
  props: {
    idFluidType: {
      type: Number,
      default: -1
    },
    idSelectedFluid: {
      type: Number,
      default: -1
    },
    fromAddToFluid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bshowRetMsg: false,
      retUptMsg: "",
      fluid: {},
      fluidRowToDelete: null,
      delete_to_fluidRow: "",
      showRowDelete: false,
      fastOptions: [
        { value: false, text: this.uniTranslation("PHE5") },
        { value: true, text: this.uniTranslation("PHE4") }
      ],
      gruppoOptions: [
        { value: "G1", text: "G1" },
        { value: "G2", text: "G2" }
      ],
      fluidList: [],
      refList: [],
      temperatureUm: "°C",
      densityUm: "kg/m³",
      specificHeatUm: "J/(kg K)",
      thermalCondUm: "W/(m K)",
      viscosityUm: "Pa s",
      temperatureUmOriginal: "°C",
      densityUmOriginal: "kg/m³",
      specificHeatUmOriginal: "J/(kg K)",
      thermalCondUmOriginal: "W/(m K)",
      viscosityUmOriginal: "Pa s",
      temperatureUmFactor: 1,
      temperatureUmOffSet: 0,
      densityUmFactor: 1,
      specificHeatUmFactor: 1,
      thermalCondUmFactor: 1,
      viscosityUmFactor: 1,
      temperatureUmDecimals: 1,
      densityUmDecimals: 1,
      specificHeatUmDecimals: 0,
      thermalCondUmDecimals: 4,
      viscosityUmDecimals: 8,
      canChangeValue: true,
      coloreFooterSfondo: "",
      coloreFooterTesto: "",
      coloreFooterBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: "",
      coloreBordo: "",
      bLoading: false,
      bShowFluidMsg: false,
      //MARCO DC 27/01/2026
      bShowDescriptionMsg: false,
      bShowMinTempMsg: false,
      bShowMaxTempMsg: false,
      bShowFreezeMsg: false,
      bShowMolecularWeightMsg: false,
      bShowPressureMsg: false,
      bShowFlashPointMsg: false
    };
  },
  computed: {
    fields: function() {
      var m_fields = [];

      if (this.fluid.tipoDati == 1) {
        m_fields = [
          { key: "id", label: this.uniTranslation("GO047") },
          {
            key: "temperature",
            label: this.uniTranslation("GF59") + " [" + this.temperatureUm + "]"
          },
          { key: "density", label: this.uniTranslation("GF58") + " [" + this.densityUm + "]" },
          {
            key: "specificHeat",
            label: this.uniTranslation("GF53") + " [" + this.specificHeatUm + ""
          },
          {
            key: "thermalConductivity",
            label: this.uniTranslation("GF51") + " [" + this.thermalCondUm + ""
          },
          { key: "viscosity", label: this.uniTranslation("GF52") + " [" + this.viscosityUm + "]" }
        ];
      } else if (this.fluid.tipoDati == 2) {
        m_fields = [
          { key: "id", label: this.uniTranslation("GO047") },
          { key: "density", label: this.uniTranslation("GF58") },
          { key: "specificHeat", label: this.uniTranslation("GF53") },
          { key: "thermalConductivity", label: this.uniTranslation("GF51") },
          { key: "viscosity", label: this.uniTranslation("GF52") }
        ];
      } else {
        m_fields = [
          { key: "id", label: this.uniTranslation("GO047") },
          { key: "fluid", label: this.uniTranslation("S422") },
          { key: "percentage", label: this.uniTranslation("PHE854") }
        ];
      }

      return m_fields;
    },
    tipoDatiOptions: function() {
      // Cipriani usa solo i POINTS
      return [{ value: 1, text: this.uniTranslation("GF124") }];

      /*
      if (this.fluid) {
        if (this.fluid.tipoFluido == 11 || this.fluid.tipoFluido == 13) {
          return [
            { value: 1, text: this.uniTranslation("GF124") },
            { value: 2, text: this.uniTranslation("GF123") },
            { value: 3, text: this.uniTranslation("GF122") }
          ];
        } else if (this.fluid.tipoFluido == 18) {
          return [{ value: 3, text: this.uniTranslation("GF122") }];
        } else if (this.fluid.tipoFluido == 14 || this.fluid.tipoFluido == 12) {
          return [
            { value: 3, text: this.uniTranslation("GF122") },
            { value: 4, text: this.uniTranslation("S840") }
          ];
        }
      }
      return [
        { value: 1, text: this.uniTranslation("GF124") },
        { value: 2, text: this.uniTranslation("GF123") },
        { value: 3, text: this.uniTranslation("GF122") },
        { value: 4, text: this.uniTranslation("S840") },
        { value: 5, text: "ICHEMA" }
      ];
      */
    },
    baseFluidList: function() {
      var list = [];
      if (this.fluid) {
        if (this.fluid.tipoDati == 3) {
          this.refList.forEach(element => {
            list.push({
              value: element.filename,
              text: element.filename
            });
          });
          return list;
        } else if (this.fluid.tipoDati == 4) {
          this.fluidList.forEach(element => {
            list.push({
              value: element.filename,
              text: element.filename
            });
          });
          return list;
        }
      }
      return [];
    },
    wrongPerc: function() {
      let atLeastOne = false;
      let total = 0;
      if (this.fluid) {
        if (this.fluid.components) {
          this.fluid.components.forEach(row => {
            atLeastOne = row.fluid + "" != "" && parseFloat(row.percentage) > 0;
            total = total + parseFloat(row.percentage);
          });
        }
      }
      return total != 100 && atLeastOne == false;
    }
  },
  watch: {
    temperatureUm: function(nv, ov) {
      var that = this;
      if (nv != "" && nv != ov) {
        umService.getUmConvInfo(that.temperatureUmOriginal, nv).then(data => {
          let fromValue = (1 - 0) * data.from.fat; /* riporto così per capire i passaggi */
          let multiplier = 1 / data.to.fat;
          let factor = fromValue * multiplier + 0;

          that.canChangeValue = true;

          that.temperatureUmFactor = factor;
          that.temperatureUmOffSet = data.to.offSet;
          that.temperatureUmDecimals = data.to.decimals;
        });
      }
    },
    densityUm: function(nv, ov) {
      var that = this;
      if (nv != "" && nv != ov) {
        umService.getUmConvInfo(that.densityUmOriginal, nv).then(data => {
          let fromValue = (1 - 0) * data.from.fat; /* riporto così per capire i passaggi */
          let multiplier = 1 / data.to.fat;
          let factor = fromValue * multiplier + 0;
          that.densityUmFactor = factor;
          that.densityUmDecimals = data.to.decimals;
        });
      }
    },
    specificHeatUm: function(nv, ov) {
      var that = this;
      if (nv != "" && nv != ov) {
        umService.getUmConvInfo(that.specificHeatUmOriginal, nv).then(data => {
          let fromValue = (1 - 0) * data.from.fat; /* riporto così per capire i passaggi */
          let multiplier = 1 / data.to.fat;
          let factor = fromValue * multiplier + 0;
          that.specificHeatUmFactor = factor;
          that.specificHeatUmDecimals = data.to.decimals;
        });
      }
    },
    thermalCondUm: function(nv, ov) {
      var that = this;
      if (nv != "" && nv != ov) {
        umService.getUmConvInfo(that.thermalCondUmOriginal, nv).then(data => {
          let fromValue = (1 - 0) * data.from.fat; /* riporto così per capire i passaggi */
          let multiplier = 1 / data.to.fat;
          let factor = fromValue * multiplier + 0;
          that.thermalCondUmDecimals = data.to.decimals;
          that.thermalCondUmFactor = factor;
        });
      }
    },
    viscosityUm: function(nv, ov) {
      var that = this;
      if (nv != "" && nv != ov) {
        umService.getUmConvInfo(that.viscosityUmOriginal, nv).then(data => {
          let fromValue = (1 - 0) * data.from.fat; /* riporto così per capire i passaggi */
          let multiplier = 1 / data.to.fat;
          let factor = fromValue * multiplier + 0;
          that.viscosityUmDecimals = data.to.decimals;
          that.viscosityUmFactor = factor;
        });
      }
    }
  },
  mounted: function() {
    var that = this;
    /*
    fluidService
      .getFluids()
      .then(function(data) {
        that.fluidList = data;
      })
      .catch(function() {});
    fluidService
      .getRefrigerants()
      .then(function(data) {
        that.refList = data;
      })
      .catch(function() {});
    */
    document.getElementById("mainOverlay").setAttribute("style", "display: none;");

    document.getElementById("mainRouterView").setAttribute("style", "");

    this.aggiorna();

    var colorList = colorsService.getColoriFooter();

    that.coloreFooterSfondo = colorList[0];
    that.coloreFooterTesto = colorList[1];
    that.coloreFooterBottoni = colorList[2] + " !important";
    that.coloreTestoBottoni = colorList[3];
    that.coloreBordoBottoni = colorList[4];
    that.coloreBordo = colorList[5];
  },
  methods: {
    assertMaxChars(maxLength) {
      if (this.fluid.fluidDescription.length >= maxLength) {
        this.fluid.fluidDescription = this.fluid.fluidDescription.substring(0, maxLength);
      }
    },

    aggiorna() {
      //alert(this.$route.params.idCliente);
      var that = this;
      let idFluid = -1;
      let fluidType = -1;
      //alert(that.fromAddToFluid);
      if (that.fromAddToFluid) {
        fluidType = that.idFluidType;
        idFluid = that.idSelectedFluid;
      } else {
        fluidType = that.$route.params.fluidType;
        idFluid = that.$route.params.idFluid;
      }
      //alert(idFluid);
      //alert(idCliente);
      if (fluidType != -1 && idFluid != -1) {
        this.readFluid(fluidType, idFluid);
      } else {
        this.newFluid(fluidType);
      }
    },
    readFluid(fluidType, idFluid) {
      var that = this;

      that.fluid = {};
      var existingFluid = false;

      fluidMgtService.getFluid(fluidType, idFluid).then(function(data) {
        var tmpFluid = data;

        tmpFluid.group = "";
        tmpFluid.vapourPressure = data.vapourPressure;
        tmpFluid.flashPointTemperature = data.flashPointTemperature;

        //that.fluid = data;
        existingFluid = true;

        // aggiungere i dati aggiunti della Tbl_FluidiGruppo
        fluidGroupService.getFluidGroup(tmpFluid.filename).then(function(data) {
          tmpFluid.group = data.group;
          tmpFluid.vapourPressure = data.vapourPressure;
          tmpFluid.flashPointTemperature = data.flashPointTemperature;
        });

        if (existingFluid == true) {
          that.fluid = tmpFluid;
        }
      });
    },
    newFluid(fluidType) {
      var that = this;
      fluidMgtService.newFluid(fluidType).then(function(data) {
        that.fluid = data;
        that.fluid.tipoDati = that.tipoDatiOptions[0].value;
      });
    },
    saveFluidDialog() {
      let anyMessagesShown = false;

      this.bShowDescriptionMsg = this.fluid.fluidDescription + "" == "";
      this.bShowMinTempMsg = false;
      this.bShowMaxTempMsg = false;
      this.bShowFreezeMsg = false;
      this.bShowMolecularWeightMsg = false;

      this.bShowFluidMsg = this.fluid.group + "" == "" || !this.fluid.group;
      this.bShowPressureMsg = this.fluid.vapourPressure + "" == "" || !this.fluid.vapourPressure;
      this.bShowFlashPointMsg =
        this.fluid.flashPointTemperature + "" == "" || !this.fluid.flashPointTemperature;

      if (this.fluid.tipoFluido == 11 || this.fluid.tipoFluido == 13) {
        this.bShowMinTempMsg = this.fluid.tempMin + "" == "";
        this.bShowMaxTempMsg = this.fluid.tempMax + "" == "";
        this.bShowFreezeMsg = this.fluid.freezingTemp + "" == "";
        if (this.fluid.tipoFluido == 13) {
          this.bShowMolecularWeightMsg = this.fluid.molecularWeight + "" == "";
        }
      }

      anyMessagesShown =
        this.bShowDescriptionMsg ||
        this.bShowMinTempMsg ||
        this.bShowMaxTempMsg ||
        this.bShowFreezeMsg ||
        this.bShowMolecularWeightMsg ||
        this.bShowFluidMsg ||
        this.bShowPressureMsg ||
        this.bShowFlashPointMsg;

      if (!anyMessagesShown) {
        this.saveFluid();
      }
    },
    goToBack() {
      this.$router.push({
        name: "fluidManagement"
      });
    },
    saveFluid() {
      var that = this;
      that.bLoading = true;

      fluidMgtService
        .updateFluid(that.fluid)
        .then(function(data) {
          var tmpFluid = data;

          var fluidGroup = {
            id: tmpFluid.id,
            filename: tmpFluid.filename,
            group: that.fluid.group,
            VapourPressure: that.fluid.vapourPressure,
            FlashPointTemperature: that.fluid.flashPointTemperature
          };

          fluidGroupService
            .updateFluidGroup(fluidGroup)
            .then(function() {
              tmpFluid.group = that.fluid.group;
              tmpFluid.vapourPressure = that.fluid.vapourPressure;
              tmpFluid.flashPointTemperature = that.fluid.flashPointTemperature;

              that.$store.dispatch("forceChangeLanguage").then(function() {
                /* retCode */
                //alert("salvato con successo");
                that.fluid = tmpFluid;
                that.retUptMsg = that.uniTranslation("GL41");
                that.bshowRetMsg = true;
              });
            })
            .catch(function() {
              that.retUptMsg = that.uniTranslation("US834");
              that.bshowRetMsg = true;
            });
        })
        .finally(() => {
          that.bLoading = false;
        })
        .catch(function() {
          //alert("errore nel salvataggio");
          that.retUptMsg = that.uniTranslation("US834");
          that.bshowRetMsg = true;
        });
    }
  }
};
</script>
